import { Chip, Tooltip, Typography } from "@mui/material";

interface Props {
  quoted: boolean;
}

export function QuotedShipmentChip(props: Props) {
  const { quoted } = props;

  if (!quoted) {
    return null;
  }

  return (
    <Tooltip title={<Typography>You have quoted this shipment</Typography>}>
      <Chip label="Quoted" color="info" variant="outlined" size="small" />
    </Tooltip>
  );
}
